export const localStorageKeys = {
  trainerUUID: "trainer-uuid",
  adminAccessToken: "admin-token",
  trainerAccessToken: "trainer-token",
  isAdmin: "is-admin",
  adminPortalIsCourseListActive: "is-course-list-active",
  adminManagementActiveTab: "management-active-tab",
};
